const isHomePage = document.querySelector( '[data-scrollable-container]' );
const isInvestorsPage = document.querySelector( '.page-template-template-investors' );
